module.exports = __webpack_public_path__ + "img/sec15mob.25a77670.png";